module.exports = __webpack_public_path__ + "img/upload.7b4009f7.svg";